<ion-item
  lines="none"
  mode="md"
  color="white"
  class="separator"
  [disabled]="!isCount"
>
  <!-- Texto de canje dinamico por tipo de promo -->
  <ion-label
    color="grayDemon"
    class="how-many-render"
    [innerHtml]="
      'Labels.' +
        (isBonus ? 'how-many-bonuses-redeem' : 'how-many-promotions-redeem')
        | translate : { equal: tipoPromocion === 'ESTATICO' ? '' : equal }
        | htmlSeguro
    "
  >
  </ion-label>

  <ng-container *ngIf="resetRange; else resetRangeFalse">
    <ion-skeleton-text
      slot="end"
      style="width: 80px; height: 30px"
    ></ion-skeleton-text>
  </ng-container>

  <ng-template #resetRangeFalse>
    <range-input
      slot="end"
      [initial]="exchange"
      [configurations]="rangeInput"
      (comeBack)="comeBack($event)"
    ></range-input>
  </ng-template>
</ion-item>
